"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.haulerManagerTypes = void 0;
exports.haulerManagerTypes = {
    SET_LOADING: 'HAULER MANAGER TYPES SET LOADING',
    SET_ERROR: 'HAULER MANAGER TYPES REDUCER SET ERROR',
    SET_DATA_GRID: 'HAULER MANAGER TYPES GET DATA GRID',
    ON_PAGE_CHANGE: 'HAULER MANAGER TYPES ON PAGE CHANGE',
    ON_MUTATION_CLICK: 'HAULER MANAGER TYPES ON MUTATION',
    ON_SORT_CHANGE: 'HAULER MANAGER TYPES ON SORT CHANGE',
    SET_DATA_DRIVER: 'HAULER MANAGER TYPES GET DATA DRIVER',
    SET_DATA_CHECKPOINT: 'HAULER MANAGER TYPES GET DATA CHECKPOINT',
    SET_DATA_HAULER: 'HAULER MANAGER TYPES GET DATA HAULER',
    SET_DATA_VESSEL_1: 'HAULER MANAGER TYPES GET DATA VESSEL 1',
    SET_DATA_VESSEL_2: 'HAULER MANAGER TYPES GET DATA VESSEL 2',
    ON_SAVE_DATAITEM: 'HAULER MANAGER TYPES ON SAVE DATAITEM',
    ON_FILTER_CHANGE: 'HAULER MANAGER TYPES ON FILTER CHANGE',
    ON_DELETE_DATAITEM: 'HAULER MANAGER TYPES ON DELETE DATAITEM',
    ON_CHANGE_DATAITEM: 'HAULER MANAGER TYPES ON CHANGE DATAITEM',
    TOGGLE_SUCCESS_MODAL: 'HAULER MANAGER TYPES SET SUCCESS MODAL',
    SET_DATA_CONTRACTOR: 'HAULER MANAGER TYPES GET DATA CONTRACTOR',
};
